/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Delete_Dialog_ConfirmInputs */

const en_ui_delete_dialog_confirm = /** @type {(inputs: Ui_Delete_Dialog_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete Everything`)
};

const de_ui_delete_dialog_confirm = /** @type {(inputs: Ui_Delete_Dialog_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alles löschen`)
};

/**
* | output |
* | --- |
* | "Delete Everything" |
*
* @param {Ui_Delete_Dialog_ConfirmInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_delete_dialog_confirm = /** @type {((inputs?: Ui_Delete_Dialog_ConfirmInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Delete_Dialog_ConfirmInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_delete_dialog_confirm(inputs)
	return de_ui_delete_dialog_confirm(inputs)
});